import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../services/store.service';
import { Store } from '@ngrx/store';
import { FormsModule } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../services/api/auth.service';
import { UserService } from '../../services/api/user.service';
import { AlertNotificationService } from '../../services/alert-notification.service';
import { MainLayoutService } from '../../services/main-layout.service';
import { TwoFactorAuthService } from '../../services/two-factor-auth.service';

@Component({
  selector: 'app-login-page',
  imports: [FormsModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {

  username: string = '';
  password: string = '';

  constructor(
    private authService: AuthService,
    private storeService: StoreService,
    private userService: UserService,
    private router: Router,
    private store: Store,
    private mainLayoutService:MainLayoutService,
    private alertNotificationService: AlertNotificationService,
    private twoFactorAuthService: TwoFactorAuthService
  ) {}

  async onSubmit(): Promise<void> {
    try {
      const response = await lastValueFrom(this.authService.token(this.username, this.password));

      if (response.status.code === 200) {
        const auth = response.data.auth;

        if (auth?.mfaRequired) {
          this.twoFactorAuthService.open(auth.mfaToken, (mfaResponse: any) => {
            const mfaAuth = mfaResponse?.data?.auth ?? mfaResponse?.auth;
            this.storeService.setAuthToken(mfaAuth);
            this.finishLogin();
          });
        } else {
          this.storeService.setAuthToken(auth);
          this.finishLogin();
        }
      } else {
        const errorMessage = response.status.error || 'Login error occurred.';
        console.error('Login error:', errorMessage);
        this.alertNotificationService.error(errorMessage);
      }
    } catch (e: any) {
      const errorMessage = e?.error?.error?.description || 'An unexpected error occurred. Please try again later.';
      console.error('An error occurred during login:', e);
      this.alertNotificationService.error(errorMessage);
    }
  }

  private finishLogin(): void {
    this.userService.getMe().subscribe({
      next: (userResponse: any) => {
        if (userResponse.status.code === 200) {
          const user = userResponse?.data?.user;
          this.storeService.setUserData(user);
          this.mainLayoutService.setUser(user);
          localStorage.setItem('user', JSON.stringify(user));

          this.alertNotificationService.success('Login successful!');
          this.router.navigate(['/app']);
        }
      },
      error: (error) => {
        const errorMessage = error?.error?.error?.description || 'Failed to fetch user data. Please try again later.';
        console.error('Error fetching user data:', error);
        this.alertNotificationService.error(errorMessage);
      }
    });
  }
}
